module.exports = __webpack_public_path__ + "img/figure-3.21d8b0ce.png";